import { render, staticRenderFns } from "./HistoryTitle.vue?vue&type=template&id=75bbb483&scoped=true&lang=pug"
import script from "./HistoryTitle.vue?vue&type=script&lang=js"
export * from "./HistoryTitle.vue?vue&type=script&lang=js"
import style0 from "./HistoryTitle.vue?vue&type=style&index=0&id=75bbb483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbb483",
  null
  
)

export default component.exports